module.exports = __webpack_public_path__ + "static/media/slider-agency-website-slide-01-image-06.99c0d65f.png";